const GLOBALID = '__'
const GLOBALTYPE = '__global'
const TOPID = '_'
const TOPTYPE = '__main'

export {
  GLOBALID,
  GLOBALTYPE,
  TOPID,
  TOPTYPE,
}
